module.exports = __webpack_public_path__ + "bmr-logo.7484280.png";